<template lang="pug">
v-app(dark)
  v-main
    component(:is="layout")
      transition(name="fade" mode="out-in")
        router-view

</template>


<script>
export default {
  name: 'Home',
  computed: {
    layout() {
      return(this.$route.meta.layout || 'centered') + '-layout'
    }
  },
  mounted() {
    this.$store.dispatch('fetchInitialData')
  }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>